/* Guarda Mundo - Product show (PDP) interactivity
 * Spec: 0008 / ADR-008; frete real: 0099 / ADR-072; Frete Expresso: gm-frete-expresso.js.
 * Shipping calculator (Frenet via Shopify rates), share, mockup detect.
 * Carregado via scripts.liquid com defer.
 */

(function () {
  'use strict';

  function init() {
    bindMockupDetect();
    bindShippingCalculator();
    bindShareButtons();
    bindMockupGalleryThumbs();
    bindIntroTabs();
    bindIntroColorThumbs();
    bindReviewsMock();
    bindExclusiveAccordions();
  }

  function bindExclusiveAccordions() {
    const groups = document.querySelectorAll('[data-gm-accordion-group]');
    groups.forEach(function (group) {
      const items = group.querySelectorAll(':scope > details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) {
              other.open = false;
            }
          });
        });
      });
    });
  }

  function bindMockupDetect() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('mockup') === '1') {
      document.body.classList.add('gm-pdp--mockup');
    }
  }

  var STORAGE_CEP = 'gm_cart_cep';
  var ASYNC_POLL_MS = 400;
  var ASYNC_MAX_ATTEMPTS = 40;
  var shippingQuoteGen = 0;

  function moneyBRL(cents) {
    return (Number(cents) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function formatCep(value) {
    var digits = String(value || '')
      .replace(/\D/g, '')
      .slice(0, 8);
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5);
    return digits;
  }

  function readStoredCep() {
    if (window.GMFreteExpresso && typeof window.GMFreteExpresso.readCep === 'function') {
      return window.GMFreteExpresso.readCep() || null;
    }
    try {
      return sessionStorage.getItem(STORAGE_CEP);
    } catch (_) {
      return null;
    }
  }

  function writeStoredCep(digits) {
    if (window.GMFreteExpresso && typeof window.GMFreteExpresso.writeCep === 'function') {
      window.GMFreteExpresso.writeCep(digits);
      return;
    }
    try {
      sessionStorage.setItem(STORAGE_CEP, digits);
    } catch (_) {
      /* ignore */
    }
  }

  function writeStoredCepGeo(geo) {
    if (window.GMFreteExpresso && typeof window.GMFreteExpresso.writeCepGeo === 'function') {
      window.GMFreteExpresso.writeCepGeo(geo);
    }
  }

  function cartBaseUrl() {
    var base =
      (window.Theme && Theme.routes && Theme.routes.cart_url) ||
      (window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root.replace(/\/?$/, '/') + 'cart'
        : '/cart');
    return String(base).replace(/\.js$/, '');
  }

  function getDeliveryDays(rate) {
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
      var max = Math.max.apply(
        null,
        rate.delivery_days.map(Number).filter(function (n) {
          return !Number.isNaN(n);
        })
      );
      return Number.isFinite(max) ? max : null;
    }
    if (Array.isArray(rate.delivery_range) && rate.delivery_range.length >= 2) {
      var end = new Date(rate.delivery_range[1]);
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      if (!Number.isNaN(end.getTime())) {
        var diff = Math.ceil((end.getTime() - start.getTime()) / 86400000);
        return diff > 0 ? diff : null;
      }
    }
    return null;
  }

  function formatRatePriceHtml(rate, freeLabel) {
    var priceNum = Number(rate && rate.price);
    var compareRaw =
      rate &&
      (rate.gm_compare_at_price != null
        ? rate.gm_compare_at_price
        : rate.compare_at_price != null
          ? rate.compare_at_price
          : rate.original_price);
    var compareNum = Number(compareRaw);
    var hasCompare =
      Number.isFinite(compareNum) && compareNum > 0 && priceNum === 0;

    if (priceNum === 0) {
      var free =
        '<span class="gm-shipping-price-free">' +
        escapeHtml(freeLabel) +
        '</span>';
      if (!hasCompare) return free;
      return (
        '<s class="gm-shipping-price-was">' +
        escapeHtml(moneyBRL(Math.round(compareNum * 100))) +
        '</s> ' +
        free
      );
    }
    return escapeHtml(moneyBRL(Math.round(priceNum * 100)));
  }

  function formatRateRow(rate, root) {
    var name = String(rate.presentment_name || rate.name || 'Frete');
    var freeLabel = root.dataset.msgFree || 'Grátis';
    var untilTpl = root.dataset.msgUntil || '(até __DAYS__ dias úteis)';
    var priceHtml = formatRatePriceHtml(rate, freeLabel);
    var eta = '';
    if (rate.gm_eta) {
      eta = String(rate.gm_eta);
    } else {
      var days = getDeliveryDays(rate);
      eta = days == null ? '' : untilTpl.replace('__DAYS__', String(days));
    }
    return { label: name, eta: eta, priceHtml: priceHtml };
  }

  function resolveVariantId(root) {
    var sizeSelected = document.querySelector(
      '[data-gm-size-option].is-selected[data-variant-id]'
    );
    if (sizeSelected) {
      return sizeSelected.getAttribute('data-variant-id') || '';
    }

    var requireSize = document.querySelector(
      '[data-gm-size-picker][data-require-selection="true"]'
    );
    if (requireSize && !sizeSelected) {
      return '';
    }

    var pfc = document.querySelector('product-form-component[data-variant-id]');
    if (pfc && pfc.getAttribute('data-variant-id')) {
      return pfc.getAttribute('data-variant-id');
    }

    var hidden = document.querySelector(
      'product-form-component input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (hidden && hidden.value) return String(hidden.value);

    var atc = document.querySelector('[data-gm-add-to-cart][data-variant-id]');
    if (atc && atc.getAttribute('data-variant-id')) {
      return atc.getAttribute('data-variant-id');
    }

    return root.getAttribute('data-variant-id') || '';
  }

  async function lookupCepGeo(digits) {
    try {
      var res = await fetch('https://viacep.com.br/ws/' + digits + '/json/');
      if (!res.ok) return null;
      var data = await res.json();
      if (data && data.erro) return null;
      var uf = typeof data.uf === 'string' && data.uf ? data.uf : '';
      var localidade =
        typeof data.localidade === 'string' && data.localidade
          ? data.localidade
          : '';
      if (uf || localidade) writeStoredCepGeo({ uf: uf, localidade: localidade });
      return uf || localidade ? { uf: uf, localidade: localidade } : null;
    } catch (_) {
      return null;
    }
  }

  function shippingAddressParams(digits, geo) {
    if (
      window.GMFreteExpresso &&
      typeof window.GMFreteExpresso.shippingAddressParams === 'function'
    ) {
      return window.GMFreteExpresso.shippingAddressParams(digits, geo);
    }
    var params = new URLSearchParams({
      'shipping_address[zip]': digits,
      'shipping_address[country]': 'Brazil',
      include_carrier_rates: 'true',
    });
    if (geo && geo.uf) params.set('shipping_address[province]', geo.uf);
    if (geo && (geo.localidade || geo.city)) {
      params.set('shipping_address[city]', geo.localidade || geo.city);
    }
    return params;
  }

  function isEmptyCartShippingError(data) {
    var err = data && data.error;
    var text = Array.isArray(err) ? err.join(' ') : String(err || '');
    return /n[aã]o exige frete|does not require shipping/i.test(text);
  }

  async function fetchAsyncShippingRates(digits, geo) {
    var params = shippingAddressParams(digits, geo);
    var base = cartBaseUrl();
    var prepareRes = await fetch(
      base + '/prepare_shipping_rates.json?' + params.toString(),
      { method: 'POST', headers: { Accept: 'application/json' } }
    );
    if (!prepareRes.ok) throw new Error('prepare_shipping_rates failed');

    var emptyCartPolls = 0;
    for (var attempt = 0; attempt < ASYNC_MAX_ATTEMPTS; attempt++) {
      var asyncRes = await fetch(
        base + '/async_shipping_rates.json?' + params.toString(),
        { headers: { Accept: 'application/json' } }
      );
      if (!asyncRes.ok) throw new Error('async_shipping_rates failed');
      var data = await asyncRes.json();
      if (data == null) {
        await new Promise(function (resolve) {
          setTimeout(resolve, ASYNC_POLL_MS);
        });
        continue;
      }
      if (isEmptyCartShippingError(data)) {
        emptyCartPolls += 1;
        if (emptyCartPolls >= 3) throw new Error('CART_EMPTY_FOR_RATES');
        await new Promise(function (resolve) {
          setTimeout(resolve, ASYNC_POLL_MS);
        });
        continue;
      }
      if (Array.isArray(data.shipping_rates)) return data.shipping_rates;
      if (data.error) {
        await new Promise(function (resolve) {
          setTimeout(resolve, ASYNC_POLL_MS);
        });
        continue;
      }
      return [];
    }

    // Fallback sync (throttled) if async never resolves
    var syncRes = await fetch(
      base + '/shipping_rates.json?' + params.toString(),
      { headers: { Accept: 'application/json' } }
    );
    if (!syncRes.ok) throw new Error('shipping_rates failed');
    var syncData = await syncRes.json();
    if (isEmptyCartShippingError(syncData)) throw new Error('CART_EMPTY_FOR_RATES');
    return Array.isArray(syncData.shipping_rates) ? syncData.shipping_rates : [];
  }

  async function getCartSnapshot() {
    var res = await fetch(cartBaseUrl() + '.js', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  async function clearCart() {
    var res = await fetch(cartBaseUrl() + '/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('cart clear failed');
    return res.json();
  }

  async function addVariantQuiet(variantId, quantity) {
    var res = await fetch(
      (window.Theme && Theme.routes && Theme.routes.cart_add_url) ||
        cartBaseUrl().replace(/\/cart$/, '/cart/add.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity || 1 }],
        }),
      }
    );
    var data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(
        (data && (data.description || data.message)) || 'cart add failed'
      );
    }
    return data;
  }

  async function restoreCartSnapshot(snapshot) {
    await clearCart();
    var items = (snapshot && snapshot.items) || [];
    if (!items.length) return;

    var payload = items.map(function (item) {
      var row = {
        id: Number(item.variant_id || item.id),
        quantity: Number(item.quantity) || 1,
      };
      if (item.properties && typeof item.properties === 'object') {
        var props = {};
        var hasProps = false;
        Object.keys(item.properties).forEach(function (key) {
          if (item.properties[key] == null || item.properties[key] === '') return;
          props[key] = String(item.properties[key]);
          hasProps = true;
        });
        if (hasProps) row.properties = props;
      }
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        row.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }
      return row;
    });

    var res = await fetch(
      (window.Theme && Theme.routes && Theme.routes.cart_add_url) ||
        cartBaseUrl().replace(/\/cart$/, '/cart/add.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: payload }),
      }
    );
    var data = await res.json();
    if (!res.ok || data.status) {
      throw new Error('cart restore failed');
    }
  }

  function setShippingBusy(root, button, busy) {
    root.classList.toggle('is-loading', busy);
    if (!(button instanceof HTMLButtonElement)) return;
    button.disabled = busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.textContent = root.dataset.msgLoading || 'Calculando…';
    } else {
      button.removeAttribute('aria-busy');
      button.textContent = root.dataset.labelButton || 'Calcular';
    }
  }

  function renderShippingError(container, message) {
    if (!container) return;
    container.innerHTML =
      '<div class="gm-pdp__shipping-row gm-pdp__shipping-row--error"><span>' +
      escapeHtml(message) +
      '</span></div>';
    container.dataset.empty = 'false';
  }

  function renderShippingResults(container, rows) {
    if (!container) return;
    var html = rows
      .map(function (row) {
        var eta = row.eta ? ' ' + escapeHtml(row.eta) : '';
        return (
          '<div class="gm-pdp__shipping-row">' +
          '<span><strong>' +
          escapeHtml(row.label) +
          '</strong>' +
          eta +
          '</span>' +
          '<span>' +
          row.priceHtml +
          '</span>' +
          '</div>'
        );
      })
      .join('');
    container.innerHTML = html;
    container.dataset.empty = 'false';
  }

  function bindShippingCalculator() {
    var roots = document.querySelectorAll('[data-gm-shipping]');
    roots.forEach(function (root) {
      var form = root.querySelector('[data-gm-shipping-form]');
      var input = root.querySelector('[data-gm-shipping-input]');
      var button = root.querySelector('[data-gm-shipping-submit]');
      var results = root.querySelector('[data-gm-shipping-results]');
      if (!form || !input || !results) return;

      var stored = readStoredCep();
      if (stored && stored.length === 8) {
        input.value = formatCep(stored);
      }

      input.addEventListener('input', function () {
        input.value = formatCep(input.value);
        var digits = input.value.replace(/\D/g, '');
        if (digits.length === 8) writeStoredCep(digits);
        else if (digits.length === 0) writeStoredCep('');
      });

      document.addEventListener('gm:size-change', function (event) {
        var detail = event && event.detail;
        if (detail && detail.variantId) {
          root.setAttribute('data-variant-id', String(detail.variantId));
        }
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        quoteShipping(root, input, button, results);
      });
    });
  }

  async function stageEstimateCart(variantId) {
    await clearCart();
    await addVariantQuiet(variantId, 1);
    var estimateCart = await getCartSnapshot();
    if (!estimateCart || !estimateCart.item_count) {
      await addVariantQuiet(variantId, 1);
      estimateCart = await getCartSnapshot();
    }
    if (!estimateCart || !estimateCart.item_count) {
      throw new Error('cart add failed');
    }
    return estimateCart;
  }

  async function quoteShipping(root, input, button, results) {
    var cep = (input.value || '').replace(/\D/g, '');
    if (cep.length !== 8) {
      renderShippingError(
        results,
        root.dataset.msgInvalid || root.dataset.msgEmpty || 'CEP inválido'
      );
      return;
    }

    var variantId = resolveVariantId(root);
    if (!variantId) {
      renderShippingError(
        results,
        root.dataset.msgSize || 'Escolha um tamanho para calcular o frete.'
      );
      return;
    }

    writeStoredCep(cep);

    // Sempre cotar carriers (Frenet). Expresso/Retirada via mergeRates — ADR-083.
    var gen = ++shippingQuoteGen;
    setShippingBusy(root, button, true);
    window.__gmShippingEstimate = true;

    var snapshot = null;
    var restoreFailed = false;
    var rates = [];
    var estimateTotalCents = 0;

    try {
      snapshot = await getCartSnapshot();
      var geo = await lookupCepGeo(cep);
      var estimateCart = await stageEstimateCart(variantId);
      estimateTotalCents = Number(estimateCart && estimateCart.total_price) || 0;
      rates = await fetchAsyncShippingRates(cep, geo);
      if (!rates.length) {
        estimateCart = await stageEstimateCart(variantId);
        estimateTotalCents = Number(estimateCart && estimateCart.total_price) || 0;
        rates = await fetchAsyncShippingRates(cep, geo);
      }
    } catch (err) {
      if (String(err && err.message) === 'CART_EMPTY_FOR_RATES') {
        try {
          var retryCart = await stageEstimateCart(variantId);
          estimateTotalCents = Number(retryCart && retryCart.total_price) || 0;
          var retryGeo = await lookupCepGeo(cep);
          rates = await fetchAsyncShippingRates(cep, retryGeo);
        } catch (_) {
          renderShippingError(
            results,
            root.dataset.msgError || 'Não foi possível calcular o frete.'
          );
          rates = null;
        }
      } else {
        renderShippingError(
          results,
          root.dataset.msgError || 'Não foi possível calcular o frete.'
        );
        rates = null;
      }
    }

    if (gen !== shippingQuoteGen) return;

    try {
      if (snapshot) {
        await restoreCartSnapshot(snapshot);
      }
    } catch (_) {
      restoreFailed = true;
      try {
        if (snapshot) await restoreCartSnapshot(snapshot);
        restoreFailed = false;
      } catch (__) {
        restoreFailed = true;
      }
    } finally {
      if (gen === shippingQuoteGen) {
        window.__gmShippingEstimate = false;
        setShippingBusy(root, button, false);
      }
    }

    if (gen !== shippingQuoteGen) return;
    if (rates == null) return;

    if (restoreFailed) {
      renderShippingError(
        results,
        root.dataset.msgRestore ||
          'Frete calculado, mas não foi possível restaurar a sacola.'
      );
      return;
    }

    if (
      window.GMFreteExpresso &&
      typeof window.GMFreteExpresso.mergeRates === 'function'
    ) {
      var thr =
        (window.GMFreteExpresso &&
          window.GMFreteExpresso.FREE_SHIP_THRESHOLD_CENTS) ||
        150000;
      rates = window.GMFreteExpresso.mergeRates(
        rates,
        cep,
        estimateTotalCents,
        thr,
        { preVenda: root.getAttribute('data-gm-pre-venda') === 'true' }
      );
    }

    if (!rates.length) {
      renderShippingError(
        results,
        root.dataset.msgError || 'Não foi possível calcular o frete.'
      );
      return;
    }

    renderShippingResults(
      results,
      rates.map(function (rate) {
        return formatRateRow(rate, root);
      })
    );
  }

  function bindShareButtons() {
    const shareRoot = document.querySelector('[data-gm-share]');
    if (!shareRoot || !navigator.share) return;

    const isMobile = window.matchMedia('(hover: none)').matches;
    if (!isMobile) return;

    const links = shareRoot.querySelectorAll('a[data-gm-share-whatsapp], a[data-gm-share-pinterest]');
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const title = document.title;
        const url = window.location.href;
        navigator
          .share({ title: title, url: url })
          .catch(function () {
            window.open(link.href, '_blank', 'noopener');
          });
      });
    });
  }

  function bindIntroTabs() {
    // Multi-instância: mobile (gm-pdp-intro-editorial) e desktop (gm-pdp-showcase__hero,
    // spec 0030) podem coexistir no mesmo DOM (um oculto via CSS por breakpoint).
    const roots = document.querySelectorAll('[data-gm-intro-tabs]');

    roots.forEach(function (root) {
      const tabs = root.querySelectorAll('[data-gm-intro-tab]');
      const panels = root.querySelectorAll('[data-gm-intro-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const target = tab.getAttribute('data-gm-intro-tab');
          if (!target) return;

          tabs.forEach(function (t) {
            const isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.tabIndex = isActive ? 0 : -1;
          });

          panels.forEach(function (panel) {
            const isActive = panel.getAttribute('data-gm-intro-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });

          // Scroll fluido (spec 0063): re-medir pin/spacer após altura da tab.
          document.dispatchEvent(new CustomEvent('gm:pdp-tabs-resize'));
        });
      });
    });
  }

  function bindIntroColorThumbs() {
    // Multi-instância: mesmo motivo de bindIntroTabs (spec 0030).
    const intros = document.querySelectorAll('[data-gm-pdp-intro]');

    intros.forEach(function (intro) {
      // querySelectorAll: no hero unico ha 2 fotos principais (main desktop na
      // coluna de info + 1o slide do carrossel mobile), ambas trocam juntas.
      const mains = intro.querySelectorAll('[data-gm-intro-main-img]');
      const colorLabel = intro.querySelector('[data-gm-intro-color-label]');
      const colorValue = intro.querySelector('[data-gm-intro-color-value]');
      const specColor = intro.querySelector('[data-gm-intro-spec-color]');
      const thumbs = intro.querySelectorAll('[data-gm-intro-color-thumb]');
      if (!thumbs.length) return;

      const titleEl = intro.querySelector(
        '.gm-pdp-hero__title, .gm-pdp-intro__title, .gm-pdp-showcase__title',
      );
      const titleText = titleEl ? titleEl.textContent.trim() : '';

      // Galeria lateral desktop (pilha) + slides secundarios do carrossel mobile
      // (spec 0034 addendum): trocam junto com a foto principal ao selecionar variante.
      const galleryImgs = intro.querySelectorAll('.gm-pdp-hero__gallery-img');
      const carouselSlideImgs = intro.querySelectorAll(
        '.gm-pdp-hero__carousel .gm-media-carousel__img',
      );

      let activeThumb = intro.querySelector('[data-gm-intro-color-thumb].is-active') || thumbs[0];

      const stripHost = intro.querySelector('[data-gm-variant-strip-host]');
      const stripEl = intro.querySelector('[data-gm-variant-strip]');
      const moreBtn = stripHost
        ? stripHost.querySelector('[data-gm-variant-more]')
        : intro.querySelector('[data-gm-variant-more]');
      const drawer = intro.querySelector('[data-gm-variant-drawer]');
      const drawerItems = intro.querySelectorAll('[data-gm-variant-drawer-item]');
      let drawerClosing = false;
      let balanceRaf = 0;

      function highlightThumb(thumb) {
        thumbs.forEach(function (t) {
          const isActive = thumb != null && t === thumb;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        const handle = thumb ? thumb.getAttribute('data-variant-handle') : '';
        drawerItems.forEach(function (item) {
          const isActive = Boolean(handle) && item.getAttribute('data-variant-handle') === handle;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function setMoreLabel(count) {
        if (!moreBtn) return;
        moreBtn.textContent = '+' + count;
        const tpl = moreBtn.getAttribute('data-more-aria') || '';
        moreBtn.setAttribute('aria-label', tpl.replace('COUNT', String(count)));
      }

      function markStripReady(mode) {
        if (!stripHost) return;
        stripHost.classList.remove('is-pending');
        stripHost.classList.add('is-ready');
        stripHost.classList.toggle('is-centered', mode === 'centered');
        stripHost.classList.toggle('is-filled', mode === 'filled');
        stripHost.removeAttribute('aria-busy');
      }

      function revealStrip(mode) {
        if (!stripEl) {
          markStripReady(mode);
          return;
        }
        const visible = Array.prototype.filter.call(
          stripEl.querySelectorAll('.gm-variant-strip__thumb'),
          function (thumb) {
            return !thumb.hidden;
          },
        );
        let pending = 0;
        let finished = false;
        function finish() {
          if (finished) return;
          finished = true;
          markStripReady(mode);
        }
        visible.forEach(function (img) {
          if (img.tagName !== 'IMG') return;
          if (img.complete) return;
          pending += 1;
          img.addEventListener('load', onOne, { once: true });
          img.addEventListener('error', onOne, { once: true });
        });
        function onOne() {
          pending -= 1;
          if (pending <= 0) finish();
        }
        if (pending <= 0) {
          finish();
          return;
        }
        window.setTimeout(finish, 1800);
      }

      // Cap fixo (spec 0129 v3): no maximo 4 slots em qualquer tela.
      // ≤4 cores: todas; >4: 3 thumbs + `+X`. A faixa pode vazar da foto.
      function slotCapacity() {
        const raw = parseInt(
          getComputedStyle(stripHost).getPropertyValue('--gm-variant-strip-slots'),
          10,
        );
        return raw > 0 ? raw : 4;
      }

      // 1 cor: a faixa some. 2 a 4 (incluindo a atual): ela fica visível, em
      // primeiro, pra preencher os slots. >4: a atual sai (já é a foto);
      // das demais, ≤cap todas e >cap vira (cap - 1) + `+X`.
      function balanceVariantStrip() {
        if (!stripHost || !stripEl || !stripHost.isConnected) return;
        const allThumbs = Array.prototype.slice.call(
          stripEl.querySelectorAll('.gm-variant-strip__thumb'),
        );
        const slotCap = slotCapacity();
        if (!allThumbs.length) {
          revealStrip();
          return;
        }

        if (allThumbs.length <= 1) {
          const swatches = stripHost.closest('.gm-pdp-hero__swatches');
          if (swatches) swatches.remove();
          else stripHost.remove();
          return;
        }

        const current =
          (activeThumb && stripEl.contains(activeThumb) && activeThumb) ||
          stripEl.querySelector('.gm-variant-strip__thumb.is-active');
        const keepCurrent = allThumbs.length <= slotCap;
        if (keepCurrent && current) {
          stripEl.insertBefore(current, stripEl.firstChild);
        }
        const stripThumbs = keepCurrent
          ? allThumbs
          : allThumbs.filter(function (thumb) {
              return thumb !== current;
            });

        allThumbs.forEach(function (thumb) {
          const hide = !keepCurrent && thumb === current;
          thumb.hidden = hide;
          if (hide) thumb.setAttribute('aria-hidden', 'true');
          else thumb.removeAttribute('aria-hidden');
        });

        if (!moreBtn || stripThumbs.length <= slotCap) {
          if (moreBtn) {
            moreBtn.hidden = true;
            moreBtn.setAttribute('tabindex', '-1');
          }
          revealStrip(stripThumbs.length < slotCap ? 'centered' : 'filled');
          return;
        }

        const visibleCap = slotCap - 1;
        for (let j = visibleCap; j < stripThumbs.length; j++) {
          stripThumbs[j].hidden = true;
          stripThumbs[j].setAttribute('aria-hidden', 'true');
        }

        moreBtn.hidden = false;
        moreBtn.setAttribute('tabindex', '0');
        setMoreLabel(stripThumbs.length - visibleCap);
        revealStrip('filled');
      }

      function scheduleBalance() {
        if (balanceRaf) cancelAnimationFrame(balanceRaf);
        balanceRaf = requestAnimationFrame(function () {
          balanceRaf = 0;
          balanceVariantStrip();
        });
      }

      function lockPageScroll() {
        const root = document.documentElement;
        const body = document.body;
        if (body.dataset.gmVariantScrollLock === '1') return;
        const y = window.scrollY || window.pageYOffset || 0;
        const gap = window.innerWidth - root.clientWidth;
        body.dataset.gmVariantScrollLock = '1';
        body.dataset.gmVariantScrollY = String(y);
        root.classList.add('gm-variant-drawer-open');
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = '-' + y + 'px';
        body.style.left = '0';
        body.style.right = '0';
        if (gap > 0) body.style.paddingRight = gap + 'px';
      }

      function unlockPageScroll() {
        const root = document.documentElement;
        const body = document.body;
        if (body.dataset.gmVariantScrollLock !== '1') return;
        const y = parseInt(body.dataset.gmVariantScrollY || '0', 10) || 0;
        root.classList.remove('gm-variant-drawer-open');
        body.style.overflow = '';
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.paddingRight = '';
        delete body.dataset.gmVariantScrollLock;
        delete body.dataset.gmVariantScrollY;
        window.scrollTo(0, y);
      }

      function openVariantDrawer() {
        if (!drawer) return;
        if (drawerClosing) return;
        hideTip();
        if (typeof drawer.showModal === 'function') {
          if (!drawer.open) drawer.showModal();
        } else {
          drawer.setAttribute('open', '');
        }
        lockPageScroll();
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
        if (moreBtn) moreBtn.setAttribute('aria-expanded', 'true');
      }

      function closeVariantDrawer() {
        if (!drawer || drawerClosing) return;
        const isOpen = drawer.open || drawer.hasAttribute('open');
        if (!isOpen) return;
        drawerClosing = true;
        drawer.classList.remove('is-open');
        if (moreBtn) moreBtn.setAttribute('aria-expanded', 'false');

        const finish = function () {
          if (!drawerClosing) return;
          drawerClosing = false;
          if (typeof drawer.close === 'function') {
            if (drawer.open) drawer.close();
          } else {
            drawer.removeAttribute('open');
          }
          unlockPageScroll();
        };

        const reduce =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          finish();
          return;
        }

        let ended = false;
        const onEnd = function (event) {
          if (event.target !== drawer) return;
          if (ended) return;
          ended = true;
          drawer.removeEventListener('transitionend', onEnd);
          finish();
        };
        drawer.addEventListener('transitionend', onEnd);
        setTimeout(onEnd.bind(null, { target: drawer }), 400);
      }

      const stockBadge = intro.querySelector('[data-gm-pdp-stock-badge]');
      const stockStates = ['in-stock', 'pre-sale', 'sold-out'];

      function applyStockFromThumb(thumb) {
        if (!stockBadge) return;
        let state = thumb.getAttribute('data-gm-stock') || 'in-stock';
        if (stockStates.indexOf(state) === -1) state = 'in-stock';
        const labelKey =
          state === 'pre-sale'
            ? 'data-label-pre-sale'
            : state === 'sold-out'
              ? 'data-label-sold-out'
              : 'data-label-in-stock';
        const label = stockBadge.getAttribute(labelKey) || '';
        stockStates.forEach(function (s) {
          stockBadge.classList.toggle('gm-pdp-hero__badge--' + s, s === state);
        });
        stockBadge.textContent = label;
      }

      // Preview leve (hover): main + labels + badge. Sem galeria/URL/commit.
      function previewMainFromThumb(thumb) {
        if (!thumb) return;
        const label = thumb.getAttribute('data-color-label') || '';
        const mainSrc = thumb.getAttribute('data-main-src') || '';

        if (colorLabel) {
          colorLabel.textContent = label;
          if (label) colorLabel.removeAttribute('hidden');
          else colorLabel.setAttribute('hidden', '');
        }
        if (colorValue) colorValue.textContent = label;
        if (specColor) specColor.textContent = label;
        applyStockFromThumb(thumb);

        if (mainSrc) {
          mains.forEach(function (main) {
            main.src = mainSrc;
            main.alt = titleText ? titleText + ' — ' + label : label;
          });
        }
      }

      function applyThumb(thumb, updateUrl) {
        activeThumb = thumb;
        highlightThumb(thumb);
        previewMainFromThumb(thumb);

        const label = thumb.getAttribute('data-color-label') || '';
        const handle = thumb.getAttribute('data-variant-handle') || '';

        const galleryAttr = thumb.getAttribute('data-gallery') || '';
        if (galleryAttr) {
          const galleryUrls = galleryAttr.split(',');
          galleryImgs.forEach(function (img, i) {
            if (galleryUrls[i]) {
              img.src = galleryUrls[i];
              img.alt = titleText ? titleText + ' — ' + label + ' ' + (i + 1) : label;
            }
          });
          // Carrossel mobile: slide 0 = main (ja tratado acima via `mains`);
          // slides seguintes = galeria (mesmo array). O indice mora no
          // <div data-gm-media-slide data-index>, nao na img (bug: lia
          // data-image-index inexistente na img e sempre caia em "0").
          carouselSlideImgs.forEach(function (img) {
            const slide = img.closest('[data-gm-media-slide]');
            const idx = parseInt((slide && slide.getAttribute('data-index')) || '0', 10);
            if (idx === 0) return;
            const url = galleryUrls[idx - 1];
            if (url) {
              img.src = url;
              img.alt = titleText ? titleText + ' — ' + label + ' ' + (idx + 1) : label;
            }
          });
        }

        // Reseta o carrossel mobile pro slide 0 ao trocar de variante (sem
        // isso, o usuario ficava "preso" na foto 2+ vendo imagens antigas).
        const carouselRoot = intro.querySelector('.gm-pdp-hero__carousel [data-gm-media-carousel]');
        if (carouselRoot) {
          const viewport = carouselRoot.querySelector('[data-gm-media-viewport]');
          if (viewport) viewport.scrollTo({ left: 0, behavior: 'auto' });
          carouselRoot.style.setProperty('--gm-media-active', '0');
        }

        if (updateUrl && handle && window.history && window.history.replaceState) {
          const productUrl = thumb.getAttribute('data-product-url') || '';
          if (productUrl) {
            const currentPath = window.location.pathname;
            try {
              const next = new URL(productUrl, window.location.origin);
              if (next.pathname !== currentPath) {
                window.location.assign(next.pathname + next.search);
                return;
              }
            } catch (e) {
              /* ignore invalid URL */
            }
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', handle);
          window.history.replaceState({}, '', url.toString());
        }
        scheduleBalance();
      }

      const isDesktop = window.matchMedia('(min-width: 750px)');
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      // Prefetch mains das variantes pra o hover nao "piscar" no 1o mouseover.
      thumbs.forEach(function (thumb) {
        const src = thumb.getAttribute('data-main-src');
        if (!src) return;
        const pre = new Image();
        pre.src = src;
      });

      // Pós-clique (spec 0129 v3): a cor clicada sai da faixa e o próximo tile
      // desliza pra baixo do cursor. O browser dispara mouseover nele e a
      // prévia trocaria título/main pra uma cor que ninguém escolheu. Trava a
      // prévia até o cursor ir pra outro tile ou sair da faixa.
      // undefined = livre; null = travado (tile sob o cursor ainda não visto).
      let hoverLockThumb;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          hoverLockThumb = null;
          applyThumb(thumb, true);

          // Desktop: ao trocar de variante, volta pro topo da página com scroll
          // suave, pra 1a foto da galeria ficar visível e dar pra rolar vendo
          // todas as fotos da nova variante desde o início.
          if (isDesktop.matches) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });

      // Desktop + hover fino: preview da main ao passar nas thumbs (sem
      // selecionar). Clique confirma variante (galeria + URL). Mouseout do
      // host restaura a variante ativa — inclui o tile +X, que tambem limpa
      // a borda da ativa. Tooltip custom (fixed): title nativo some quando
      // highlight/preview muta o DOM.
      const hoverRoot = stripHost || intro.querySelector('[data-gm-variant-strip]');
      let tipEl = null;
      let tipThumb = null;

      function ensureTip() {
        if (tipEl) return tipEl;
        tipEl = document.createElement('div');
        tipEl.className = 'gm-variant-strip__tip';
        tipEl.setAttribute('role', 'tooltip');
        tipEl.hidden = true;
        document.body.appendChild(tipEl);
        return tipEl;
      }

      function positionTip(thumb) {
        if (!tipEl || !thumb) return;
        const rect = thumb.getBoundingClientRect();
        tipEl.style.left = Math.round(rect.left + rect.width / 2) + 'px';
        tipEl.style.top = Math.round(rect.bottom) + 'px';
      }

      function showTip(thumb) {
        const label =
          thumb.getAttribute('data-gm-tooltip') ||
          thumb.getAttribute('data-color-label') ||
          '';
        if (!label) {
          hideTip();
          return;
        }
        const tip = ensureTip();
        tip.textContent = label;
        tip.hidden = false;
        tipThumb = thumb;
        positionTip(thumb);
        // rAF: aplica .is-visible após paint pra transição de opacity rodar.
        requestAnimationFrame(function () {
          if (tipThumb === thumb) tip.classList.add('is-visible');
        });
      }

      function hideTip() {
        tipThumb = null;
        if (!tipEl) return;
        tipEl.classList.remove('is-visible');
        tipEl.hidden = true;
      }

      if (hoverRoot) {
        hoverRoot.addEventListener('mouseover', function (e) {
          if (!isDesktop.matches || !canHover.matches) return;
          const target = e.target;
          if (!(target instanceof Element)) return;
          if (moreBtn && !moreBtn.hidden && (target === moreBtn || moreBtn.contains(target))) {
            hideTip();
            highlightThumb(null);
            previewMainFromThumb(activeThumb);
            return;
          }
          const thumb = target.closest('[data-gm-intro-color-thumb]');
          if (!thumb || !hoverRoot.contains(thumb) || thumb.hidden) return;
          if (hoverLockThumb !== undefined) {
            if (hoverLockThumb === null || hoverLockThumb === thumb) {
              hoverLockThumb = thumb;
              return;
            }
            hoverLockThumb = undefined;
          }
          highlightThumb(thumb);
          previewMainFromThumb(thumb);
          showTip(thumb);
        });

        hoverRoot.addEventListener('mouseout', function (e) {
          if (!isDesktop.matches || !canHover.matches) return;
          const related = e.relatedTarget;
          if (related instanceof Element && hoverRoot.contains(related)) return;
          hoverLockThumb = undefined;
          hideTip();
          highlightThumb(activeThumb);
          previewMainFromThumb(activeThumb);
        });

        // Reposiciona se scroll/resize mover a faixa sob o cursor.
        window.addEventListener(
          'scroll',
          function () {
            if (tipThumb) positionTip(tipThumb);
          },
          { passive: true, capture: true },
        );
        window.addEventListener('resize', function () {
          if (tipThumb) positionTip(tipThumb);
        });
      }

      // Restaura a variante a partir do param ?variant= no load.
      const wanted = new URLSearchParams(window.location.search).get('variant');
      if (wanted) {
        thumbs.forEach(function (thumb) {
          if (thumb.getAttribute('data-variant-handle') === wanted) {
            applyThumb(thumb, false);
          }
        });
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (moreBtn.hidden) return;
          openVariantDrawer();
        });
      }

      if (drawer) {
        drawer.addEventListener('cancel', function (event) {
          event.preventDefault();
          closeVariantDrawer();
        });
        drawer.addEventListener('click', function (event) {
          if (event.target === drawer) closeVariantDrawer();
        });
        const closeBtns = drawer.querySelectorAll('[data-gm-variant-drawer-close]');
        closeBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            closeVariantDrawer();
          });
        });
        drawerItems.forEach(function (item) {
          item.addEventListener('click', function () {
            const handle = item.getAttribute('data-variant-handle');
            let match = null;
            thumbs.forEach(function (thumb) {
              if (thumb.getAttribute('data-variant-handle') === handle) match = thumb;
            });
            if (!match) return;
            applyThumb(match, true);
            if (isDesktop.matches) {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            closeVariantDrawer();
          });
        });
      }

      if (stripHost && stripEl) {
        scheduleBalance();
        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(function () {
            scheduleBalance();
          });
          ro.observe(stripHost);
        } else {
          window.addEventListener('resize', scheduleBalance);
        }
      }
    });
  }

  function bindMockupGalleryThumbs() {
    const main = document.querySelector('[data-gm-mockup-main-img]');
    const thumbs = document.querySelectorAll('[data-gm-thumb-index]');
    if (!main || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.removeAttribute('data-active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.setAttribute('data-active', 'true');
        thumb.setAttribute('aria-selected', 'true');

        const img = thumb.querySelector('img');
        if (img && main) {
          main.src = img.src;
          main.alt = img.alt;
        }
      });
    });
  }

  function bindReviewsMock() {
    const buttons = document.querySelectorAll('[data-gm-reviews-write]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (window.alert) {
          window.alert('Avaliações em breve. Funcionalidade em desenvolvimento.');
        }
      });
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
